<mat-slide-toggle
  class="toggle"
  [hideIcon]="true"
  [checked]="checked"
  (change)="onToggleChange($event)"
>
  {{ label }}
</mat-slide-toggle>
